import { BaseDto } from './base.dto';
// import { MerchantGroupDto } from './merchantGroup.dto';

export class PaymentMethodMerchantGroupDto extends BaseDto {
  paymentMethodId: number;
  merchantGroupId: number;
//   merchantGroup?: MerchantGroupDto;
}